[
  {
    "key": "SUBMUNITIONS_SMALL",
    "label": "Submunitions",
    "type": "submunitions",
    "size": "74MM x 57MM & Below",
    "evacuationRadius": 368
  },
  {
    "key": "SUBMUNITIONS_LARGE",
    "label": "Submunitions",
    "type": "submunitions",
    "size": "75MM x 58MM & Above",
    "evacuationRadius": 585
  },
  {
    "key": "GRENADES_SMALL",
    "label": "Grenades",
    "type": "grenades",
    "size": "74MM x 57MM & Below",
    "evacuationRadius": 368
  },
  {
    "key": "GRENADES_LARGE",
    "label": "Grenades",
    "type": "grenades",
    "size": "75MM x 58MM & Above",
    "evacuationRadius": 585
  },
  {
    "key": "AP_LANDMINES_SMALL",
    "label": "AP Landmines",
    "type": "landmines",
    "size": "112MM x 63MM & Below",
    "evacuationRadius": 421
  },
  {
    "key": "AP_LANDMINES_LARGE",
    "label": "AP Landmines",
    "type": "landmines",
    "size": "113MM x 64MM & Above",
    "evacuationRadius": 620
  },
  {
    "key": "AT_LANDMINES_SMALL",
    "label": "AT Landmines",
    "type": null,
    "size": "81MM x 249MM & Below",
    "evacuationRadius": 518
  },
  {
    "key": "AT_LANDMINES_LARGE",
    "label": "AT Landmines",
    "type": null,
    "size": "82MM x 250MM & Above",
    "evacuationRadius": 658
  },
  {
    "key": "PROJECTILES_SMALL",
    "label": "Projectiles",
    "type": "mortar-projectiles",
    "size": "85MM x 344MM & Below",
    "evacuationRadius": 412
  },
  {
    "key": "PROJECTILES_MEDIUM",
    "label": "Projectiles",
    "type": "mortar-projectiles",
    "size": "from 86MM x 345MM to 121MM x 500MM",
    "evacuationRadius": 511
  },
  {
    "key": "PROJECTILES_LARGE",
    "label": "Projectiles",
    "type": "mortar-projectiles",
    "size": "122MM x 501MM & Above",
    "evacuationRadius": 707
  },
  {
    "key": "MORTARS_SMALL",
    "label": "Mortars",
    "type": "mortars",
    "size": "60MM x 210MM & Below",
    "evacuationRadius": 340
  },
  {
    "key": "MORTARS_MEDIUM",
    "label": "Mortars",
    "type": "mortars",
    "size": "from 61MM x 211MM to 100MM x 280MM",
    "evacuationRadius": 503
  },
  {
    "key": "MORTARS_LARGE",
    "label": "Mortars",
    "type": "mortars",
    "size": "101MM x 281MM & Above",
    "evacuationRadius": 818
  },
  {
    "key": "ROCKETS_SMALL",
    "label": "Rockets",
    "type": "rockets",
    "size": "68MM x 425MM & Below",
    "evacuationRadius": 271
  },
  {
    "key": "ROCKETS_MEDIUM",
    "label": "Rockets",
    "type": "rockets",
    "size": "from 69MM x 426MM to 107MM x 840MM",
    "evacuationRadius": 548
  },
  {
    "key": "ROCKETS_LARGE",
    "label": "Rockets",
    "type": "rockets",
    "size": "108MM x 841MM & Above",
    "evacuationRadius": 911
  },
  {
    "key": "BOMBS_SMALL",
    "label": "Bombs",
    "type": "bombs",
    "size": "194MM x 1M & Below",
    "evacuationRadius": 510
  },
  {
    "key": "BOMBS_MEDIUM",
    "label": "Bombs",
    "type": "bombs",
    "size": "From 195MM x 1.01M to 325MM x 1.46M",
    "evacuationRadius": 1079
  },
  {
    "key": "BOMBS_LARGE",
    "label": "Bombs",
    "type": "bombs",
    "size": "326MM x 1.47M & Above",
    "evacuationRadius": 1969
  },
  {
    "key": "GUIDED_MISSILES_SMALL",
    "label": "Guided Missiles",
    "type": "guided-missiles",
    "size": "127MM x 3M & Below",
    "evacuationRadius": 564
  },
  {
    "key": "GUIDED_MISSILES_MEDIUM",
    "label": "Guided Missiles",
    "type": "guided-missiles",
    "size": "From 128MM x 3.01M to 254MM x 4.15M",
    "evacuationRadius": 1023
  },
  {
    "key": "GUIDED_MISSILES_LARGE",
    "label": "Guided Missiles",
    "type": "guided-missiles",
    "size": "255MM x 4.16M & Above",
    "evacuationRadius": 1922
  },
  {
    "key": "UNKNOWN",
    "label": "Unknown",
    "type": "unknown",
    "size": "",
    "evacuationRadius": 500
  },
  {
    "key": "OTHER_POSSIBLE_OSSEOUS_MATERIAL",
    "label": "Possible Osseous Material",
    "type": "other",
    "size": "",
    "evacuationRadius": 0
  },
  {
    "key": "OTHER_POSSIBLE_MATERIAL_EVIDENCE",
    "label": "Possible Material Evidence",
    "type": "other",
    "size": "",
    "evacuationRadius": 0
  },
  {
    "key": "OTHER_POSSIBLE_LIFE_SUPPORT_EQUIPMENT",
    "label": "Possible Life Support Equipment",
    "type": "other",
    "size": "",
    "evacuationRadius": 0
  },
  {
    "key": "OTHER_POSSIBLE_AIRCRAFT_WRECKAGE",
    "label": "Possible Aircraft Wreckage",
    "type": "other",
    "size": "",
    "evacuationRadius": 0
  },
  { 
    "key": "AIRDRONE_SMALL", 
    "label": "Air Drone",
    "type": "airdrone", 
    "size": "< 150kg", 
    "evacuationRadius": 0
  },
  { 
    "key": "AIRDRONE_MEDIUM", 
    "label": "Air Drone",
    "type": "airdrone", 
    "size": "150 - 600kg", 
    "evacuationRadius": 0
  },
  { 
    "key": "AIRDRONE_LARGE", 
    "label": "Air Drone",
    "type": "airdrone", 
    "size": "> 600kg", 
    "evacuationRadius": 0
  },
  { 
    "key": "LANDDRONE_SMALL", 
    "label": "Land Drone",
    "type": "landdrone", 
    "size": "< 200kg", 
    "evacuationRadius": 0
  },
  { 
    "key": "LANDDRONE_MEDIUM", 
    "label": "Land Drone",
    "type": "landdrone", 
    "size": "200kg - 2T", 
    "evacuationRadius": 0
  },
  { 
    "key": "LANDDRONE_LARGE", 
    "label": "Land Drone",
    "type": "landdrone", 
    "size": "> 2T", 
    "evacuationRadius": 0
  },
  { 
    "key": "SEADRONE_SURFACE", 
    "label": "Sea Drone",
    "type": "seadrone", 
    "size": "", 
    "evacuationRadius": 0
  },
  { 
    "key": "SEADRONE_UNDERWATER", 
    "label": "Sea Drone",
    "type": "seadrone", 
    "size": "", 
    "evacuationRadius": 0
  }
]
